import Phaser from "phaser";
import { actionEvaluation } from "./actionEvaluation";
import { cDisplay, createParam } from "./cDisplay";
import { infoBubble } from "./cDisplayObjects/infoBubble";
import { popupChoice } from "./cDisplayObjects/popupChoice";
import { speechBubble } from "./cDisplayObjects/speechBubble";
import { cGame } from "./cGame";
import { cInlineDisplay } from "./cGameObjects/cInlineDisplay";
import { ScreenAsset, ScreenItem, ScreenObject } from "./dataTypes";
import { net } from "./utils/net";
import { setLocalStrings } from "./utils/simpleLocalisation";
import { logging } from "./utils/logging";

export interface cSceneConfig {
  loader?: any
  sceneOptions?: any
}


export class cScene extends Phaser.Scene {

  public debugMode: boolean = false
  public sceneData!: ScreenObject
  public sceneStyles: any
  public display!: cDisplay;
  public ev: Phaser.Events.EventEmitter

  public soundData: any;

  protected actionEval!: actionEvaluation
  private _updateCallback: Function[] = [];
  private unloadlist!: string[]
  public savedPath!: string;
  public customeOptions: any

  static assetFolder: string = 'assets/';
  static soundVolume: number = 100;
  static soundOn: boolean = true;

  static createPack(key: string, data: string | ScreenObject): any {
    if (typeof data === 'string') {
      return [{ key: '_scenedata_' + key, type: 'json', url: 'screen.json' }]
    } else {
      return null
    }
  }

  static setLoader(name: string, config: cSceneConfig | undefined) {
    var res: any = { ...{}, ...config }
    res.crossOrigin = 'anonymous'
    res.path = net.serverUrl +  net.gamedataFolder + name 
    console.log('scene_loader', res.path)
    return res
  }


  /**
   * 
   * @param key 
   * @param data 
   * @param config 
   */
  constructor(key: string, data: ScreenObject | string, config?: cSceneConfig) {
    super({
      key: key,
      pack: { files: cScene.createPack(key, data) as any },
      loader: cScene.setLoader(key, config) as any
    });

    this.debugMode = cGame.debugmode;

    this.soundData = {}

    if (config && config.sceneOptions) {
      this.customeOptions = config.sceneOptions
    }

    this.ev = new Phaser.Events.EventEmitter()
    this.ev.addListener('action', (a: any, b: any) => {
      this.command('custome_' + b.command, b)
    })

    if (typeof data !== 'string') {
      this.sceneData = data
      this.init();
    }
  }

  public applyOptions(options: any) {
    this.customeOptions = options;
    this.ev.emit('options')
  }


  /**
   *
   *
   * @memberof cScene
   */
  init() {
    if (!this.sceneData) {
      var cfg: ScreenObject = this.cache.json.get('_scenedata_' + this.sys.settings.key)
      if (cfg) {
        this.sceneData = cfg
      }
    }

    if (this.sceneData) {
      setLocalStrings(this.sceneData.strings)
      this.sceneStyles = (this.sceneData.options && this.sceneData.options.style) ? this.sceneData.options.style : {};
      if (this.sceneData.actions) {
        this.actionEval = new actionEvaluation(this, this.sceneData.actions)
      }
      var nm = String(this.sceneData.options.name).substring(0, 4)
      switch (nm) {
        case 'grun': cGame.current.state.set('module', 1); break
        case 'wahl': cGame.current.state.set('module', 2); break
      }
    }
    this.ev.emit('init');
  }


  parseFilename(n:string):string{
    if (n.indexOf('[LANG]') !== -1){
      console.log(cGame.language);
      n = n.replace('[LANG]',cGame.language);
    }
    return n
  }


  /**
   * 
   * @param assetlist 
   * @param path 
   */
  preload(assetlist: ScreenAsset[] | null = null, path?: string) {
    this.events.emit('start-loading')

    if (!this.savedPath) this.savedPath = this.load.path

    let assetToLoad: ScreenAsset[] | undefined;

    if (assetlist !== null) {
      assetToLoad = assetlist
    } else if (this.sceneData) {
      assetToLoad = this.sceneData.assets
    } else {
      assetToLoad = []
    }

    this.load.path = path ? path : this.savedPath
    this.unloadlist = [];
    var prog: any = {}

    if (assetToLoad) {
      assetToLoad.forEach((obj: ScreenAsset, i) => {
        if (obj.debugOnly && !this.debugMode) return
        switch (obj.type) {
          case 'sprite':
            this.load.image(obj.name, this.parseFilename(cScene.assetFolder + obj.url));
            break;
          case 'spritesheet':
            this.load.spritesheet(obj.name, this.parseFilename(cScene.assetFolder + obj.url), { frameWidth: Number(obj.width), frameHeight: Number(obj.height) });
            break;
          case 'spriteatlas':
            this.load.atlas(obj.name, this.parseFilename(cScene.assetFolder + obj.url), this.parseFilename(cScene.assetFolder + String(obj.url).replace('.png', '.json')));
            break;
          case 'sound':
            var opt: any = {}
            if (obj.streamAudio === true) opt.stream = true;
            if (obj.audioInstances) opt.instances = obj.audioInstances;
            this.load.audio(obj.name, this.parseFilename(cScene.assetFolder + obj.url), opt)
            break;
          case 'soundsprite':
            this.load.audioSprite(obj.name, this.parseFilename(cScene.assetFolder + String(obj.url).replace('.mp3', '.json')), this.parseFilename(cScene.assetFolder + obj.url));
            break;

        }
        if (!obj.preventUnload) this.unloadlist.push(obj.name);
        prog[obj.name] = 0
      })
    }

    var prog_total: number = Object.keys(prog).length;

    this.load.on('fileprogress', (v: any, val: any) => {
      prog[v.key] = val;
      var total: number = 0;
      Object.keys(prog).forEach((ke) => {
        total += prog[ke] / prog_total
      });
      cGame.current.ev.emit('load_progress', total)
    });

    this.load.on('complete', (v: any) => {
      cGame.current.ev.emit('load_complete')
    });

    cGame.current.ev.emit('load_start')

  }



  create() {
    cGame.current.ev.emit('load_complete')
    this.sys.setVisible(false);

    if (!this.sceneData) return

    var isOverlay = (this.customeOptions && this.customeOptions.isOverlay);

    if (this.sceneData.options.name.charAt(0) !== '_' && !isOverlay) {
      cGame.current.state.set('current_scene', this.sceneData.options.name);
    }

    var props: createParam = {
      type: this.sceneData.options.type,
      scene: this,
      data: this.sceneData.screen as any,
      onReady: () => {
      }
    }

    if (typeof this.sceneData.options.type != 'undefined' && cDisplay.DisplayTypeExists(this.sceneData.options.type)) {
      this.display = cDisplay.createDisplayType.call(null, props as any);
    } else {
      this.display = new cDisplay(props.scene, props.data, props.onReady);
    }

    this.display.events.addListener('action', (action: string, el: any, data: ScreenItem) => {
      if (action === 'click') {
        this.actionEval.start("on_click_" + data.name, {})
      }
    })

    if (this.sceneData.options.displayShift && this.debugMode) {
      this.display.x = Number(this.sceneData.options.displayShift)
    }

    this.add.existing(this.display);
    this.events.emit('created');

    if (this.sceneData.options.swipe && !this.debugMode) {
      this.createMask(this.sceneData.options.swipe, () => {
        this.ev.emit('ready');
      });
    } else {
      this.ev.emit('ready');
    }

    setTimeout(() => {
      this.actionEval.start('on_enter', this.customeOptions || {})
      this.sys.setVisible(true);
      this.createBackgroundMusic()
    }, 1)
  }



  createBackgroundMusic(){
    if (this.sceneData.options.bgsound){
      this.actionEval.process('x',{},{
        "type": "customNode",
        "name": "sndaction",
        "props": {
          "name": this.sceneData.options.bgsound,
          "key": this.sceneData.options.bgsound,
          "control": "play",
          "volume": "0:100",
          "duration": "2000",
          "config": "{\"loop\":1}"
        },
        "output":{}
      })
    }
  }

  stopBackgroundMusic(){
    if (this.sceneData.options.bgsound){
      this.actionEval.process('x',{},{
        "type": "customNode",
        "name": "sndaction",
        "props": {
          "name": this.sceneData.options.bgsound,
          "key": this.sceneData.options.bgsound,
          "volume": "0",
          "duration": "2000",
          "config": "{}"
        },
        "output":{}
      })
    }

  }


  update() {
    if (this._updateCallback.length > 0) {
      this._updateCallback.forEach((f) => {
        f();
      })
    }
  }

  public updateHook(f: Function) {
    this._updateCallback.push(f);
  }


  createMask(swipetype: string, cb: Function) {
    const shape = new Phaser.GameObjects.Graphics(this);

    shape.fillStyle(0xffffff);
    shape.beginPath();

    shape.moveTo(0, 0);
    shape.fillRect(0, 0, 1920, 1080);
    shape.fillPath();

    const mask = shape.createGeometryMask();
    this.display.setMask(mask)

    const animOptions: any = {
      duration: 1000,
      targets: shape,
      ease: Phaser.Math.Easing.Cubic.InOut,
      completed: () => {
        setTimeout(() => {
          cb()
          this.display.clearMask();
        }, 800)
      }
    }


    switch (swipetype) {
      case 'hrz-center':
        shape.x = 1920 / 2;
        shape.y = 0;
        shape.scaleX = 0.01

        animOptions.x = 0;
        animOptions.scaleX = 1;
    }

    this.tweens.add(animOptions)

  }

  public triggerSceneEvent(name: string, data: any = {}) {
    data.event = name
    this.actionEval.start('on_sceneevent', data)
  }


  protected createInlineDisplay(options: any, cb?: Function) {
    var inlineDisp: cInlineDisplay
    var onExit = (command: string, opt: any) => {
      if (opt.command === 'close_inline') {
        this.ev.removeListener('action', onExit);
        if (cb) {
          cb();
        }
      }
    }
    inlineDisp = new cInlineDisplay(this, { id: '', name: options.name, type: '', asset: options.asset }, () => { });
    inlineDisp.modules.layout.setOfs(options.offset);
    this.ev.addListener('action', onExit);
    if (options.target) {
      var r = this.display.getByName(options.target);
      if (r) {
        (r as Phaser.GameObjects.Container).add(inlineDisp)
      }
    } else {
      this.add.existing(inlineDisp)
    }
  }


  public command(name: string, options: any, cb?: Function) {
    //console.log('SCENE (' + this.sceneData.options.name + ')__', name)
    switch (name) {
      case 'goto':
        this.ev.emit('action', 'goto', options)
        break;
      case 'custome_mute_sound':
        (cGame.current.game as any).sound.mute = options.options === '1'
        break;
      case 'speechbubble':
        console.log('bubble',options);
        let sp = new speechBubble(this, options, () => {
          cb && cb({});
        })
        sp.name = 'speechbubble';
        this.add.existing(sp)
        if (options.target) {
          var tg = this.getByName(options.target);
          tg.add(sp);
        }
        break;
      case 'speechbubblechoice':
        let ch = new popupChoice(this, options, (opt: any) => {
          cb && cb(opt);
        })
        ch.name = 'popupchoice';
        this.add.existing(ch)
        break;
      case 'inlinedisplay':
        this.createInlineDisplay(options, cb)
        break;
      case 'hint':
        console.log('HINT')
        let hi = new infoBubble(this, options, () => {
          cb && cb();
        })
        hi.name = 'hint';
        this.add.existing(hi)
        break;
      case 'custome_close_hint':
        var items = this.children.getAll();
        items.forEach((el) => {
          if (el instanceof infoBubble) {
            el.close();
            console.log('::>',el)
          }
        })
        break;
      case 'custome_close_speechbubble':
        var spb: speechBubble = this.children.getByName('speechbubble') as speechBubble;
        if (spb) {
          spb.close();
        }
        break;
      case 'custome_scene_completed':
        cGame.current.state.set('scene_completed_' + options.options, 1);
        cGame.current.state.set('scene_last_completed', options.options);
        break;
      case 'custome_global_reset':
        cGame.current.handleCommand('global_reset', {})
        break;
      case 'custome_scene_reset':
        cGame.current.handleCommand('scene_reset', {})
        break;
      case 'custome':
        this.ev.emit('action', 'command', options)
        break;
      default:
        cb && cb(options)
    }
  }


  public getState(id?: string) {
    var r = cGame.current.state.get(String(this.sceneData.options.name), {})
    if (id) {
      return r[id] ? r[id] : 0
    } else {
      return r;
    }
  }

  public setState(id: string, value: any) {
    var r = cGame.current.state.get(String(this.sceneData.options.name), {})
    r[id] = value
    cGame.current.state.set(String(this.sceneData.options.name), r)
  }

  public snd(id: string, opt: any = {}) {
    if (!this.soundData[id]) {
      try {
        this.soundData[id] = this.sound.add(id);
      } catch (e) {

      }
    }
    if (opt && opt.loop) this.soundData[id].loop = opt.loop;
    this.soundData[id].play('', opt);
    // if (cScene.soundOn){
    //   this.soundData[id].unmute()
    // }else{
    //   this.soundData[id].mute();
    // }  
    return this.soundData[id];
  }


  public static muteSound(opt: boolean) {

  }

  public getById(id: string) {
    if (this.display) return this.display.getById(id)
    return null;
  }

  public getByName(id: string) {
    return this.display.getByName(id)
  }

  public getStyle(name: string) {
    let s = { ...cGame.current.getStyle(name) };
    if (this.sceneStyles[name]) {
      s = { ...s, ...this.sceneStyles[name] }
    }
    return s;
  }

  public close(cb?: Function) {
    logging.log('CLOSING SCENE !', this.sceneData.options.name);
    if (typeof this.actionEval != 'undefined') {
      this.actionEval.start('on_exit', {})
    }
    this.display.close(() => {
      cGame.current.game.scene.remove(this.sceneData.options.name as string)
      this.ev.removeAllListeners()
      setTimeout(() => this.cleanup(), 200)
      cb && cb()
    })
    this.stopBackgroundMusic();
  }


  private cleanup() {
    this.unloadlist.forEach((e) => {
      this.textures.remove(e)
    })
  }

} 